<div class="book-preview-cover-wrapper" [style.width.px]="coverDisplayWidth" [style.height.px]="coverDisplayHeight">
  <div class="cover-clipping-rect">
    <img #coverImage class="cover-image" src="">
    <p class="loading-text" i18n="@@Loading Image">Loading Image</p>
    <!-- Trim cut lines (red dotted) -->
    <!-- Top bleed line -->
    <div class="cut-line hor-cut" [style.top.px]="bleed - 1"></div>
    <!-- Bottom bleed line -->
    <div class="cut-line hor-cut" [style.bottom.px]="bleed - 1"></div>
    <!-- Left bleed line -->
    <div class="cut-line vert-cut" [style.left.px]="bleed - 1"></div>
    <!-- Right bleed line -->
    <div class="cut-line vert-cut" [style.right.px]="bleed - 1"></div>
    <!-- Left spine line -->
    <div class="cut-line vert-cut" [style.left.px]="spineLeftOffset"></div>
    <!-- Right spine line -->
    <div class="cut-line vert-cut" [style.left.px]="spineRightOffset"></div>
  </div>
</div>

